module.exports = __webpack_public_path__ + "static/media/aw1.0c4cd15f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/aw1.png
// module id = 1365
// module chunks = 0